import ErrorHandler from './error-handler';
import {generateUrl, getSetting} from './settings';

let defaultHeaders = {};

// Add csrf token to default headers if we got one
const csrfToken = getSetting('security.csrfToken');
if (csrfToken) {
    defaultHeaders['X-CSRF-Token'] = csrfToken;
}
const activeErrorHandler = new ErrorHandler();

// process a fetch call with the try catch logic & optional inspector
const doFetch = async (url, params, inspector, silentErrors = false) => {
    try {
        // we will keep the start timestamp so we can calculate the time of a call
        let timestampStart = (new Date()).getTime();

        const request = await fetch(url, params);

        // if something when't wrong
        if ( ! request.ok)  {
            const error = await request.text();
            // we throw the error of the request
            throw ({code: request.status, message: error});
        }

        const response = await request.json();

        if(inspector) {
            // calculate the time of a call and set it to the optional inspector
            inspector.milliseconds = (new Date()).getTime() - timestampStart
        }

        return response;
    } catch (error) {
        if (! silentErrors) {
            activeErrorHandler.handleError(error);
            throw error;
        }
    }
};

export const get = async (path, params, signal, inspector, silentErrors) => {
    const url = generateUrl(path, params);

    return doFetch(url, {
        method: 'GET',
        headers: defaultHeaders,
        params,
        signal
    }, inspector, silentErrors);
}

export const post = async (path, data, params, signal, inspector, silentErrors) => {
	const url = generateUrl(path, params);
	const body = JSON.stringify(data);

    return await doFetch(url, {
        method: 'POST',
        body,
        headers: defaultHeaders,
        signal
    }, inspector, silentErrors);
}

export const put = async (path, data, params, signal, inspector, silentErrors) => {
	const url = generateUrl(path, params);
    const body = JSON.stringify(data);

    return await doFetch(url, {
        method: 'PUT',
        body,
        headers: defaultHeaders,
        signal
    },  inspector, silentErrors);
}

/**
 * Set default header
 * @param headerLabel
 * @param value
 */
export const setDefaultHeader = (headerLabel, value) => {
    defaultHeaders[headerLabel] = value;
}

/**
 * Remove default header
 * @param headerLabel
 */
export const removeDefaultHeader = (headerLabel) => {
    delete defaultHeaders[headerLabel];
}


const dataManager = {
    install: (Vue) => {
        Vue.prototype.$get = (url, params, signal, inspector, silentErrors) => get(url, params,  signal, inspector, silentErrors);
        Vue.prototype.$post = (url, data, params,  signal, inspector, silentErrors) => post(url, data, params,  signal, inspector, silentErrors);
        Vue.prototype.$put = (url, data, params,  signal, inspector, silentErrors) => put(url, data, params,  signal, inspector, silentErrors);
        Vue.prototype.$setDefaultHeader = (headerLabel, value) => setDefaultHeader(headerLabel, value);
        Vue.prototype.$removeDefaultHeader = (headerLabel) => removeDefaultHeader(headerLabel);
        Vue.prototype.$errors = Vue.observable(activeErrorHandler.errors);
    }
}

export default dataManager;
